/**
 * @fileoverview GET handler for the "/engagement/:app_group_id/sms_inbound_message_keyword_categories" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";

import { engagementAppGroupIdSmsInboundMessageKeywordCategories } from "./constants";
import type { EngagementAppGroupIdSmsInboundMessageKeywordCategoriesResult } from "./types";
import { isEngagementAppGroupIdSmsInboundMessageKeywordCategoriesResult } from "./validators";

export const getEngagementAppGroupIdSmsInboundMessageKeywordCategories = reactQueryFetcherAdapter(
  engagementAppGroupIdSmsInboundMessageKeywordCategories,
  (
    signal: AbortSignal,
    appGroupId: string,
    subscriptionGroupId: string,
    limit: number
  ): Promise<EngagementAppGroupIdSmsInboundMessageKeywordCategoriesResult> => {
    return fetch(
      `/engagement/${appGroupId}/sms_inbound_message_keyword_categories`,
      "GET",
      { subscription_group_id: subscriptionGroupId, query: null, limit: limit },
      { signal }
    );
  },
  isEngagementAppGroupIdSmsInboundMessageKeywordCategoriesResult
);
